import ServicesConfiguration from './Configuration';
import Services from './Services';

export default Services;
export { ServicesConfiguration };
